import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { IFormValues } from "../../../../../types";
import { FormTextField } from "../../../../../../../components/fields";

const SubstitutionDetails = () => {

    const { t } = useTranslation('booking');

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}
                              sx={{
                                  '.MuiAccordionSummary-content': {
                                      justifyContent: "space-between",
                                      alignItems: "center"
                                  }
                              }}
            >
                <Typography variant="h5">
                    {t('label.substitutionDetails')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.substitution"
                            label={t('label.substitution')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.dropoffLocation"
                            label={t('label.dropoffLocation_car_to_replace')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.dropoffDate"
                            label={t('label.dropoffDate_car_to_replace')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.dropoffTime"
                            label={t('label.dropoffTime_car_to_replace')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
};

export default SubstitutionDetails;
